import { shape, id, digest, integer, choice, check, immutable } from './browser-values.mjs';

export const G11_VERSION_KEYS = Object.freeze([
  'bindingVersion',
  'bindingDigest',
  'queryTemplateDigest',
  'readPlanDigest',
  'companyPolicyVersion',
  'companyConnectionPolicyVersion',
  'companyConnectionPolicyDigest',
  'connectionEpoch',
  'grantEpoch',
  'authorityEpoch',
]);
const digestKeys = [
  'bindingDigest',
  'queryTemplateDigest',
  'readPlanDigest',
  'companyConnectionPolicyDigest',
];
const numberKeys = ['bindingVersion', 'connectionEpoch', 'grantEpoch', 'authorityEpoch'];

export function parseG11ExpectedVersions(value) {
  shape(value, G11_VERSION_KEYS, [], 'expectedVersions');
  for (const field of digestKeys) digest(value[field], field);
  for (const field of numberKeys) integer(value[field], field);
  for (const field of ['companyPolicyVersion', 'companyConnectionPolicyVersion'])
    id(value[field], field);
  return immutable(value);
}
export function parseG11ReadyProjection(value) {
  shape(
    value,
    [
      'status',
      'declaredBinding',
      'bindingVersion',
      'bindingDigest',
      'expectedVersions',
      'accessPartitionRef',
      'accessPartitionDigest',
    ],
    [],
    'ready',
  );
  choice(value.status, ['ready'], 'status');
  for (const field of ['declaredBinding', 'accessPartitionRef']) id(value[field], field);
  digest(value.bindingDigest, 'bindingDigest');
  digest(value.accessPartitionDigest, 'accessPartitionDigest');
  integer(value.bindingVersion, 'bindingVersion');
  parseG11ExpectedVersions(value.expectedVersions);
  check(
    value.bindingVersion === value.expectedVersions.bindingVersion &&
      value.bindingDigest === value.expectedVersions.bindingDigest,
    'binding_versions',
  );
  return immutable(value);
}
